import { sortAsc } from '../utils/sortOptions';
import { useState, useEffect } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import { ChevronRightIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
  .tc * { box-sizing:border-box; }
  .tc { font-family:'Sora',sans-serif; color:#1a1d2e; animation:tcFade .4s ease both; }
  @keyframes tcFade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
  .tc-header { display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:1.5rem; flex-wrap:wrap; gap:1rem; }
  .tc-title  { font-size:1.35rem; font-weight:700; letter-spacing:-.02em; color:#0f1123; }
  .tc-sub    { font-size:.76rem; color:#9094a8; margin-top:3px; }

  .btn { display:inline-flex; align-items:center; gap:7px; padding:9px 16px; border:none; border-radius:10px; font-family:'Sora',sans-serif; font-size:.8rem; font-weight:600; cursor:pointer; transition:all .18s; }
  .btn svg { width:15px; height:15px; stroke-width:2; }
  .btn-green { background:#10c98e; color:white; }
  .btn-green:hover { background:#0db87e; }
  .btn-ghost { background:#f0f2f7; color:#6b7194; }
  .btn-ghost:hover { background:#e4e7f0; }
  .btn-sm { padding:6px 11px; font-size:.74rem; }
  .btn:disabled { opacity:.5; cursor:not-allowed; transform:none !important; }

  .mode-banner { display:flex; align-items:center; gap:8px; padding:9px 14px; border-radius:10px; font-size:.76rem; font-weight:600; margin-bottom:1.2rem; }
  .mode-banner.single { background:#ecfdf5; color:#065f46; border:1px solid #a7f3d0; }
  .mode-banner.period { background:#eef2ff; color:#3730a3; border:1px solid #c7d2fe; }

  .card-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:1rem; margin-bottom:1.4rem; }
  .class-card { background:white; border-radius:14px; border:1px solid #e8ebf4; padding:1.1rem 1.2rem; cursor:pointer; transition:all .15s; }
  .class-card:hover  { border-color:#3b6ef8; box-shadow:0 4px 16px rgba(59,110,248,.1); transform:translateY(-1px); }
  .class-card.active { border-color:#3b6ef8; background:#f5f8ff; }
  .cc-name  { font-size:.95rem; font-weight:700; color:#0f1123; margin-bottom:4px; }
  .cc-count { font-size:.75rem; color:#9094a8; }
  .cc-arrow { display:flex; align-items:center; justify-content:space-between; margin-top:10px; }
  .cc-arrow svg { width:16px; height:16px; stroke:#3b6ef8; stroke-width:2; }

  .panel { background:white; border-radius:16px; border:1px solid #e8ebf4; overflow:hidden; margin-bottom:1rem; }
  .panel-head { display:flex; align-items:flex-start; justify-content:space-between; padding:14px 18px; border-bottom:1px solid #f0f2f8; flex-wrap:wrap; gap:10px; }
  .panel-title { font-size:.86rem; font-weight:600; color:#1a1d2e; }

  .tab-row { display:flex; gap:4px; flex-shrink:0; }
  .tab-btn { padding:6px 14px; border-radius:8px; border:1.5px solid #e0e4f0; font-family:'Sora',sans-serif; font-size:.76rem; font-weight:600; cursor:pointer; transition:all .15s; background:white; color:#6b7194; white-space:nowrap; }
  .tab-btn.active { background:#3b6ef8; color:white; border-color:#3b6ef8; }

  /* Period tabs */
  .period-tabs { display:flex; gap:5px; padding:10px 18px; background:#fafbff; border-bottom:1px solid #f0f2f8; flex-wrap:wrap; }
  .period-tab { padding:5px 13px; border-radius:8px; border:1.5px solid #e0e4f0; font-family:'Sora',sans-serif; font-size:.74rem; font-weight:600; cursor:pointer; background:white; color:#6b7194; transition:all .15s; white-space:nowrap; }
  .period-tab.active   { background:#3b6ef8; color:white; border-color:#3b6ef8; }
  .period-tab.saved    { border-color:#10c98e; color:#10c98e; background:#ecfdf5; }
  .period-tab.active.saved { background:#10c98e; color:white; border-color:#10c98e; }

  .std-table { width:100%; border-collapse:collapse; }
  .std-table thead { background:#fafbff; border-bottom:1px solid #edf0f9; }
  .std-table th { padding:10px 18px; text-align:center !important; font-size:.65rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.07em; white-space:nowrap; }
  .std-table tbody tr { border-bottom:1px solid #f3f5fb; transition:background .12s; }
  .std-table tbody tr:last-child { border-bottom:none; }
  .std-table tbody tr:hover { background:#fafbff; }
  .std-table td { padding:11px 18px; font-size:.8rem; vertical-align:middle; text-align:center !important; }

  .std-cards { display:none; padding:10px; }
  .std-card  { background:#fafbff; border-radius:10px; border:1px solid #e8ebf4; padding:11px 13px; margin-bottom:7px; }
  .sc-row    { display:flex; align-items:center; justify-content:space-between; font-size:.76rem; padding:3px 0; border-bottom:1px solid #f0f2f8; gap:8px; }
  .sc-row:last-child { border-bottom:none; }
  .sc-label  { color:#9094a8; font-weight:600; white-space:nowrap; }

  .att-cards { display:none; padding:10px; }
  .att-card  { background:#fafbff; border-radius:10px; border:1px solid #e8ebf4; padding:11px 13px; margin-bottom:7px; }
  .ac-top    { display:flex; align-items:center; justify-content:space-between; margin-bottom:8px; gap:8px; }
  .ac-controls { display:flex; align-items:center; gap:12px; margin-top:6px; flex-wrap:wrap; }
  .ac-control-item { display:flex; align-items:center; gap:6px; font-size:.76rem; color:#6b7194; font-weight:600; }

  .att-checkbox { width:20px; height:20px; border-radius:5px; border:2px solid #d1d5db; cursor:pointer; appearance:none; -webkit-appearance:none; transition:all .15s; flex-shrink:0; position:relative; }
  .att-checkbox:checked { background:#10c98e; border-color:#10c98e; }
  .att-checkbox:checked::after { content:'✓'; position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); color:white; font-size:.72rem; font-weight:700; }
  .att-checkbox.late-cb:checked { background:#f59e0b; border-color:#f59e0b; }
  .att-checkbox:hover:not(:disabled) { border-color:#10c98e; }
  .att-checkbox.late-cb:hover:not(:disabled) { border-color:#f59e0b; }
  .att-checkbox:disabled { opacity:.3; cursor:not-allowed; }

  .status-pill { display:inline-flex; font-size:.67rem; font-weight:600; padding:3px 9px; border-radius:99px; }
  .status-pill.present  { background:#ecfdf5; color:#10c98e; }
  .status-pill.absent   { background:#fef2f2; color:#ef4444; }
  .status-pill.late     { background:#fffbeb; color:#f59e0b; }
  .status-pill.on-leave { background:#eef2ff; color:#3b6ef8; }

  .late-input { width:60px; font-family:'JetBrains Mono',monospace; font-size:.76rem; padding:4px 7px; border:1.5px solid #e0e4f0; border-radius:7px; background:#f8f9fc; outline:none; text-align:center; }
  .late-input:focus { border-color:#f59e0b; background:white; }

  .t-avatar { width:30px; height:30px; border-radius:8px; background:#eef2ff; color:#3b6ef8; display:flex; align-items:center; justify-content:center; font-size:.7rem; font-weight:700; flex-shrink:0; }

  .att-toolbar { display:flex; align-items:center; gap:12px; padding:12px 18px; background:#fafbff; border-bottom:1px solid #f0f2f8; flex-wrap:wrap; }
  .att-date-input { font-family:'Sora',sans-serif; font-size:.82rem; padding:7px 11px; border:1.5px solid #e0e4f0; border-radius:9px; background:white; outline:none; }
  .att-date-input:focus { border-color:#3b6ef8; }
  .att-hint { font-size:.74rem; color:#9094a8; }

  .att-summary { display:flex; gap:12px; padding:10px 18px; background:#f8f9fc; border-bottom:1px solid #f0f2f8; flex-wrap:wrap; }
  .att-sum-item { font-size:.74rem; font-weight:600; }
  .att-sum-item.present { color:#10c98e; }
  .att-sum-item.absent  { color:#ef4444; }
  .att-sum-item.late    { color:#f59e0b; }

  .mark-all-row { display:flex; gap:8px; padding:10px 18px; border-bottom:1px solid #f0f2f8; align-items:center; flex-wrap:wrap; }
  .mark-all-label { font-size:.76rem; color:#6b7194; font-weight:500; }

  .save-footer { padding:14px 18px; border-top:1px solid #f0f2f8; display:flex; align-items:center; justify-content:space-between; gap:10px; flex-wrap:wrap; }
  .save-footer .btn-green { flex-shrink:0; }

  .tc-empty   { text-align:center; padding:3rem 2rem; color:#9094a8; font-size:.82rem; }
  .tc-loading { display:flex; align-items:center; justify-content:center; height:200px; gap:10px; color:#9094a8; }
  .spinner { width:18px; height:18px; border:2px solid #e4e7f0; border-top-color:#10c98e; border-radius:50%; animation:spin .7s linear infinite; }
  @keyframes spin { to{transform:rotate(360deg);} }

  @media (max-width:768px) {
    .tc-title { font-size:1.1rem; }
    .panel-head { flex-direction:column; align-items:stretch; gap:10px; }
    .tab-row { width:100%; }
    .tab-btn { flex:1; justify-content:center; }
    .att-toolbar { flex-direction:column; align-items:flex-start; gap:8px; }
    .att-date-input { width:100%; }
    .std-table-wrap  { display:none !important; }
    .std-cards       { display:block; }
    .att-table-wrap  { display:none !important; }
    .att-cards       { display:block; }
    .save-footer { flex-direction:column; align-items:stretch; }
    .save-footer .btn-green { width:100%; justify-content:center; }
  }
`;

const initials = (n='') => n.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase() || '?';
// Local (not UTC) calendar date — toISOString() always returns the UTC date, which
// can be a different calendar day than local time near midnight and would then
// disagree with the server's (also local-date-based) "today" comparisons.
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};

const TeacherClasses = () => {
  const [classes,       setClasses]       = useState([]);
  const [activeClass,   setActiveClass]   = useState(null);
  const [section,       setSection]       = useState('');
  const [students,      setStudents]      = useState([]);
  const [tab,           setTab]           = useState('students');
  const [loading,       setLoading]       = useState(true);
  const [saving,        setSaving]        = useState(false);
  const [isLocked,      setIsLocked]      = useState(false);
  const [canMark,       setCanMark]       = useState(true);
  const [attDate,       setAttDate]       = useState(todayStr());
  const [attendance,    setAttendance]    = useState({});

  // Attendance mode from school settings
  const [attMode,       setAttMode]       = useState('single'); // 'single' | 'period'
  const [periodsPerDay, setPeriodsPerDay] = useState(8);

  // Period mode state
  const [activePeriod,  setActivePeriod]  = useState(1);
  // savedPeriods: set of period numbers already saved for this date+class+section
  const [savedPeriods,  setSavedPeriods]  = useState(new Set());
  // periodAttendance: { [period]: { [studentId]: { status, lateMinutes, attendanceId } } }
  const [periodAtt,     setPeriodAtt]     = useState({});

  useEffect(() => { fetchClasses(); fetchAttMode(); }, []);
  useEffect(() => { if (activeClass && section) fetchStudents(); }, [activeClass, section]);
  useEffect(() => {
    if (activeClass && section && tab === 'attendance') {
      if (attMode === 'single') fetchDailyAttendance();
      else fetchAllPeriodsAttendance();
    }
  }, [attDate, tab, attMode]);

  const fetchAttMode = async () => {
    try {
      const { data } = await api.get('/admin/settings/attendance');
      setAttMode(data.attendanceMode || 'single');
      setPeriodsPerDay(data.periodsPerDay || 8);
    } catch { /* default to single */ }
  };

  const fetchClasses = async () => {
    try { setLoading(true); const {data} = await api.get('/teacher/classes'); setClasses(data.classes || []); }
    catch { toast.error('Failed to load classes'); } finally { setLoading(false); }
  };

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const sectionParam = section ? `?section=${section}` : '';
      const {data} = await api.get(`/teacher/classes/${activeClass._id}/students${sectionParam}`);
      setStudents(data);
    } catch { toast.error('Failed to load students'); } finally { setLoading(false); }
  };

  // ── SINGLE MODE ──────────────────────────────────────────────────────────────
  const fetchDailyAttendance = async () => {
    if (!activeClass || !section) return;
    try {
      const {data} = await api.get(`/teacher/student-attendance?classId=${activeClass._id}&section=${section}&date=${attDate}`);
      setIsLocked(data.isLocked || false);
      setCanMark(data.isClassTeacher !== false);
      const map = {};
      data.students.forEach(s => {
        map[s.studentId] = { status: s.status || 'absent', lateMinutes: s.lateMinutes || 0, attendanceId: s.attendanceId || null };
      });
      setAttendance(map);
    } catch {
      setIsLocked(false);
      const map = {};
      students.forEach(s => { map[s._id] = { status: 'absent', lateMinutes: 0, attendanceId: null }; });
      setAttendance(map);
    }
  };

  // ── PERIOD MODE ──────────────────────────────────────────────────────────────
  const fetchAllPeriodsAttendance = async () => {
    if (!activeClass || !section) return;
    try {
      const {data} = await api.get(`/teacher/student-attendance/periods?classId=${activeClass._id}&section=${section}&date=${attDate}`);
      // data.periods: [ { period, subject, isLocked, students: [{studentId, status, lateMinutes, attendanceId}] } ]
      const byPeriod = {};
      const savedSet = new Set();
      (data.periods || []).forEach(p => {
        const map = {};
        p.students.forEach(s => {
          map[s.studentId] = { status: s.status || 'absent', lateMinutes: s.lateMinutes || 0, attendanceId: s.attendanceId || null };
        });
        byPeriod[p.period] = map;
        if (p.students.some(s => s.attendanceId)) savedSet.add(p.period);
      });
      setPeriodAtt(byPeriod);
      setSavedPeriods(savedSet);
      setIsLocked(data.isLocked || false);
      setCanMark(data.isClassTeacher !== false);
      // Load active period's attendance into working state
      loadPeriodIntoAtt(byPeriod, activePeriod);
    } catch {
      setPeriodAtt({});
      setSavedPeriods(new Set());
      resetAttendance();
    }
  };

  const loadPeriodIntoAtt = (byPeriod, period) => {
    const existing = byPeriod[period];
    if (existing && Object.keys(existing).length > 0) {
      setAttendance(existing);
    } else {
      // Default all absent for this period
      const map = {};
      students.forEach(s => { map[s._id] = { status: 'absent', lateMinutes: 0, attendanceId: null }; });
      setAttendance(map);
    }
  };

  const switchPeriod = (period) => {
    // Save current period state before switching
    if (attMode === 'period') {
      setPeriodAtt(prev => ({ ...prev, [activePeriod]: attendance }));
    }
    setActivePeriod(period);
    loadPeriodIntoAtt({ ...periodAtt, [activePeriod]: attendance }, period);
  };

  const resetAttendance = () => {
    const map = {};
    students.forEach(s => { map[s._id] = { status: 'absent', lateMinutes: 0, attendanceId: null }; });
    setAttendance(map);
  };

  const openClass = (cls) => {
    setActiveClass(cls); setTab('students');
    const secs = sortAsc(cls.sections || []);
    setSection(secs.length > 0 ? secs[0] : '');
    setStudents([]); setAttendance({}); setPeriodAtt({}); setSavedPeriods(new Set()); setActivePeriod(1); setCanMark(true);
  };

  const switchTab = (t) => {
    setTab(t);
    if (t === 'attendance') {
      resetAttendance();
      if (attMode === 'single') fetchDailyAttendance();
      else fetchAllPeriodsAttendance();
    }
  };

  // ── Checkbox logic ────────────────────────────────────────────────────────
  const togglePresent = (studentId) => {
    setAttendance(prev => {
      const cur = prev[studentId]?.status;
      const newStatus = (cur === 'absent' || !cur) ? 'present' : 'absent';
      return { ...prev, [studentId]: { ...prev[studentId], status: newStatus, lateMinutes: newStatus === 'absent' ? 0 : prev[studentId]?.lateMinutes || 0 } };
    });
  };

  const toggleLate = (studentId) => {
    setAttendance(prev => {
      const cur = prev[studentId]?.status;
      if (cur === 'late') return { ...prev, [studentId]: { ...prev[studentId], status: 'present', lateMinutes: 0 } };
      return { ...prev, [studentId]: { ...prev[studentId], status: 'late', lateMinutes: prev[studentId]?.lateMinutes || 0 } };
    });
  };

  const setLateMinutes = (studentId, mins) => {
    setAttendance(prev => ({ ...prev, [studentId]: { ...prev[studentId], lateMinutes: Number(mins) || 0 } }));
  };

  const markAll = (status) => {
    const map = {};
    students.forEach(s => { map[s._id] = { status, lateMinutes: 0, attendanceId: attendance[s._id]?.attendanceId || null }; });
    setAttendance(map);
  };

  // ── Save single mode ──────────────────────────────────────────────────────
  const saveAttendance = async () => {
    if (!activeClass || !section || !canMark) return;
    try {
      setSaving(true);
      const marks = students.map(s => ({
        studentId:   s._id,
        status:      attendance[s._id]?.status || 'absent',
        lateMinutes: attendance[s._id]?.lateMinutes || 0,
      }));
      await api.post('/teacher/student-attendance', { classId: activeClass._id, section, date: attDate, attendance: marks });
      toast.success(`Attendance saved for ${new Date(attDate).toLocaleDateString('en-US', { day:'numeric', month:'short' })}`);
      fetchDailyAttendance();
    } catch { toast.error('Failed to save attendance'); } finally { setSaving(false); }
  };

  // ── Save period mode ──────────────────────────────────────────────────────
  const savePeriodAttendance = async () => {
    if (!activeClass || !section || !canMark) return;
    try {
      setSaving(true);
      // Merge latest attendance state into periodAtt
      const currentPeriodAtt = { ...periodAtt, [activePeriod]: attendance };
      const marks = students.map(s => ({
        studentId:   s._id,
        status:      currentPeriodAtt[activePeriod]?.[s._id]?.status || 'absent',
        lateMinutes: currentPeriodAtt[activePeriod]?.[s._id]?.lateMinutes || 0,
      }));
      await api.post('/teacher/student-attendance', {
        classId:  activeClass._id,
        section,
        date:     attDate,
        period:   activePeriod,
        attendance: marks,
        attendanceMode: 'period',
      });
      toast.success(`Period ${activePeriod} attendance saved`);
      setSavedPeriods(prev => new Set([...prev, activePeriod]));
      fetchAllPeriodsAttendance();
    } catch { toast.error('Failed to save attendance'); } finally { setSaving(false); }
  };

  const presentCount = students.filter(s => attendance[s._id]?.status === 'present').length;
  const absentCount  = students.filter(s => attendance[s._id]?.status === 'absent').length;
  const lateCount    = students.filter(s => attendance[s._id]?.status === 'late').length;

  const periods = Array.from({ length: periodsPerDay }, (_, i) => i + 1);

  return (
    <div className="tc"><style>{style}</style>

      <div className="tc-header">
        <div><div className="tc-title">My Classes</div><div className="tc-sub">View students and mark attendance</div></div>
      </div>

      {/* Mode banner */}
      <div className={`mode-banner ${attMode}`}>
        {attMode === 'single'
          ? '📋 Single Attendance Mode — one record per student per day'
          : `📅 Period Attendance Mode — separate attendance for each of ${periodsPerDay} periods`}
      </div>

      {loading && !activeClass ? (
        <div className="tc-loading"><div className="spinner"/>Loading…</div>
      ) : classes.length === 0 ? (
        <div className="tc-empty">No classes assigned yet.</div>
      ) : (
        <div className="card-grid">
          {classes.map(cls => (
            <div key={cls._id} className={`class-card ${activeClass?._id === cls._id ? 'active' : ''}`} onClick={() => openClass(cls)}>
              <div className="cc-name">{cls.name}</div>
              {cls.isClassTeacher && (
                <div style={{fontSize:'.68rem',fontWeight:700,color:'#10c98e',marginBottom:4}}>
                  ★ Class Teacher{cls.classTeacherSection ? ` — Section ${cls.classTeacherSection}` : ''}
                </div>
              )}
              <div className="cc-count" style={{marginBottom:6}}>{cls.studentCount} student{cls.studentCount !== 1 ? 's' : ''} total</div>
              {cls.sections?.length > 0 && (
                <div style={{display:'flex',gap:5,flexWrap:'wrap',marginBottom:6}}>
                  {cls.sections.map(s => (
                    <span key={s} style={{fontSize:'.68rem',fontWeight:600,padding:'2px 9px',borderRadius:99,background:'#eef2ff',color:'#3b6ef8'}}>Section {s}: {cls.sectionCounts?.[s] || 0}</span>
                  ))}
                </div>
              )}
              <div className="cc-arrow"><span style={{fontSize:'.72rem',color:'#3b6ef8',fontWeight:600}}>View class</span><ChevronRightIcon /></div>
            </div>
          ))}
        </div>
      )}

      {activeClass && (
        <div className="panel">
          <div className="panel-head">
            <div>
              <div className="panel-title">{activeClass.name}</div>
              {activeClass.sections?.length > 1 && (
                <div style={{display:'flex',gap:6,marginTop:6,flexWrap:'wrap'}}>
                  {sortAsc(activeClass.sections).map(s => (
                    <button key={s} onClick={() => setSection(s)}
                      style={{padding:'3px 12px',borderRadius:99,border:'1.5px solid',fontFamily:"'Sora',sans-serif",fontSize:'.72rem',fontWeight:600,cursor:'pointer',background:section===s?'#3b6ef8':'white',color:section===s?'white':'#6b7194',borderColor:section===s?'#3b6ef8':'#e0e4f0'}}>
                      Section {s}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div className="tab-row">
              <button className={`tab-btn ${tab === 'students' ? 'active' : ''}`} onClick={() => setTab('students')}>Students</button>
              <button className={`tab-btn ${tab === 'attendance' ? 'active' : ''}`} onClick={() => switchTab('attendance')}>Mark Attendance</button>
            </div>
          </div>

          {/* ── STUDENTS TAB ── */}
          {tab === 'students' && (
            loading ? <div className="tc-loading"><div className="spinner"/>Loading…</div>
            : students.length === 0 ? <div className="tc-empty">No students in this class{section ? ` / Section ${section}` : ''}</div>
            : (
              <>
                <div className="std-table-wrap" style={{overflowX:'auto'}}>
                  <table className="std-table">
                    <thead><tr><th>#</th><th>Student</th><th>Roll No</th><th>Admission No</th><th>Email</th></tr></thead>
                    <tbody>
                      {students.map((s, i) => (
                        <tr key={s._id}>
                          <td style={{color:'#9094a8',fontFamily:"'JetBrains Mono',monospace",fontSize:'.74rem'}}>{i+1}</td>
                          <td><div style={{display:'flex',alignItems:'center',gap:9}}><div className="t-avatar">{initials(s.user?.name)}</div><div style={{fontWeight:600,fontSize:'.82rem',color:'#0f1123'}}>{s.user?.name}</div></div></td>
                          <td style={{fontFamily:"'JetBrains Mono',monospace",fontSize:'.78rem',color:'#6b7194'}}>{s.rollNo}</td>
                          <td style={{fontFamily:"'JetBrains Mono',monospace",fontSize:'.78rem',color:'#6b7194'}}>{s.admissionNo}</td>
                          <td style={{fontSize:'.75rem',color:'#9094a8'}}>{s.user?.email}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="std-cards">
                  {students.map((s) => (
                    <div key={s._id} className="std-card">
                      <div style={{display:'flex',alignItems:'center',gap:9,marginBottom:6}}>
                        <div className="t-avatar">{initials(s.user?.name)}</div>
                        <div style={{fontWeight:600,fontSize:'.84rem',color:'#0f1123'}}>{s.user?.name}</div>
                      </div>
                      <div className="sc-row"><span className="sc-label">Roll No</span><span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:'.76rem',color:'#6b7194'}}>{s.rollNo}</span></div>
                      <div className="sc-row"><span className="sc-label">Admission No</span><span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:'.76rem',color:'#6b7194'}}>{s.admissionNo}</span></div>
                      <div className="sc-row"><span className="sc-label">Email</span><span style={{fontSize:'.74rem',color:'#9094a8'}}>{s.user?.email}</span></div>
                    </div>
                  ))}
                </div>
              </>
            )
          )}

          {/* ── ATTENDANCE TAB ── */}
          {tab === 'attendance' && (
            <>
              <div className="att-toolbar">
                <div style={{display:'flex',alignItems:'center',gap:6,width:'100%',maxWidth:320}}>
                  <button className="btn btn-ghost btn-sm" style={{padding:'6px 10px'}} onClick={() => { const d=new Date(attDate); d.setDate(d.getDate()-1); setAttDate(d.toISOString().slice(0,10)); }}>←</button>
                  <input type="date" className="att-date-input" style={{flex:1}} value={attDate} onChange={e => setAttDate(e.target.value)} />
                  <button className="btn btn-ghost btn-sm" style={{padding:'6px 10px'}} onClick={() => { const d=new Date(attDate); d.setDate(d.getDate()+1); setAttDate(d.toISOString().slice(0,10)); }} disabled={attDate >= todayStr()}>→</button>
                </div>
                {isLocked && <div style={{display:'flex',alignItems:'center',gap:6,background:'#fffbeb',border:'1px solid #fde68a',borderRadius:8,padding:'6px 12px',fontSize:'.76rem',color:'#92400e',fontWeight:600}}>🔒 Locked — admin only</div>}
                {!isLocked && canMark && <span className="att-hint">{attMode === 'period' ? `Period ${activePeriod} of ${periodsPerDay}` : '✓ Present | ⏰ Late | Unchecked = Absent'}</span>}
              </div>

              {!canMark && (
                <div style={{display:'flex',alignItems:'center',gap:8,margin:'0 18px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:10,padding:'10px 14px',fontSize:'.78rem',color:'#991b1b',fontWeight:600}}>
                  🚫 Restricted — you are not the class teacher of this section. You can view students but cannot mark attendance.
                </div>
              )}

              {/* ── PERIOD TABS (period mode only) ── */}
              {attMode === 'period' && (
                <div className="period-tabs">
                  {periods.map(p => (
                    <button
                      key={p}
                      className={`period-tab ${activePeriod===p?'active':''} ${savedPeriods.has(p)?'saved':''}`}
                      onClick={() => switchPeriod(p)}>
                      P{p} {savedPeriods.has(p) ? '✓' : ''}
                    </button>
                  ))}
                </div>
              )}

              {!isLocked && canMark && (
                <div className="mark-all-row">
                  <span className="mark-all-label">Mark all:</span>
                  <button className="btn btn-ghost btn-sm" onClick={() => markAll('present')}>✓ All Present</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => markAll('absent')}>✗ All Absent</button>
                </div>
              )}

              {students.length > 0 && (
                <div className="att-summary">
                  <span className="att-sum-item present">✓ Present: {presentCount}</span>
                  <span className="att-sum-item absent">✗ Absent: {absentCount}</span>
                  {lateCount > 0 && <span className="att-sum-item late">⏰ Late: {lateCount}</span>}
                  {attMode === 'period' && <span style={{fontSize:'.74rem',color:'#3b6ef8',fontWeight:600,marginLeft:'auto'}}>Period {activePeriod}</span>}
                </div>
              )}

              {students.length === 0 ? <div className="tc-empty">No students to mark.</div> : (
                <>
                  {/* Desktop table */}
                  <div className="att-table-wrap" style={{overflowX:'auto'}}>
                    <table className="std-table">
                      <thead>
                        <tr>
                          <th>#</th><th>Student</th><th>Roll No</th>
                          <th style={{textAlign:'center'}}>Present</th>
                          <th style={{textAlign:'center'}}>Late</th>
                          <th>Late Min</th><th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {students.map((s, i) => {
                          const att       = attendance[s._id] || { status: 'absent', lateMinutes: 0 };
                          const isPresent = att.status === 'present';
                          const isLateS   = att.status === 'late';
                          return (
                            <tr key={s._id}>
                              <td style={{color:'#9094a8',fontFamily:"'JetBrains Mono',monospace",fontSize:'.74rem'}}>{i+1}</td>
                              <td><div style={{display:'flex',alignItems:'center',gap:9}}><div className="t-avatar">{initials(s.user?.name)}</div><div style={{fontWeight:600,fontSize:'.82rem',color:'#0f1123'}}>{s.user?.name}</div></div></td>
                              <td style={{fontFamily:"'JetBrains Mono',monospace",fontSize:'.78rem',color:'#6b7194'}}>{s.rollNo}</td>
                              <td style={{textAlign:'center'}}>
                                <input type="checkbox" className="att-checkbox" checked={isPresent} disabled={isLocked || !canMark} onChange={() => !isLocked && canMark && togglePresent(s._id)} />
                              </td>
                              <td style={{textAlign:'center'}}>
                                <input type="checkbox" className="att-checkbox late-cb" checked={isLateS} disabled={isLocked || !canMark} onChange={() => !isLocked && canMark && toggleLate(s._id)} title="" />
                              </td>
                              <td>
                                {isLateS
                                  ? <input type="number" className="late-input" value={att.lateMinutes||''} min={1} max={120} placeholder="min" onChange={e=>setLateMinutes(s._id,e.target.value)} />
                                  : <span style={{color:'#d1d5db',fontSize:'.74rem'}}>—</span>}
                              </td>
                              <td><span className={`status-pill ${att.status}`}>{att.status}</span></td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile cards */}
                  <div className="att-cards">
                    {students.map((s) => {
                      const att       = attendance[s._id] || { status: 'absent', lateMinutes: 0 };
                      const isPresent = att.status === 'present';
                      const isLateS   = att.status === 'late';
                      return (
                        <div key={s._id} className="att-card">
                          <div className="ac-top">
                            <div style={{display:'flex',alignItems:'center',gap:9}}>
                              <div className="t-avatar">{initials(s.user?.name)}</div>
                              <div>
                                <div style={{fontWeight:600,fontSize:'.84rem',color:'#0f1123'}}>{s.user?.name}</div>
                                <div style={{fontSize:'.7rem',color:'#9094a8',fontFamily:"'JetBrains Mono',monospace"}}>Roll: {s.rollNo}</div>
                              </div>
                            </div>
                            <span className={`status-pill ${att.status}`}>{att.status}</span>
                          </div>
                          <div className="ac-controls">
                            <label className="ac-control-item">
                              <input type="checkbox" className="att-checkbox" checked={isPresent} disabled={isLocked || !canMark} onChange={() => !isLocked && canMark && togglePresent(s._id)} />Present
                            </label>
                            <label className="ac-control-item">
                              <input type="checkbox" className="att-checkbox late-cb" checked={isLateS} disabled={isLocked || !canMark} onChange={() => !isLocked && canMark && toggleLate(s._id)} />Late
                            </label>
                            {isLateS && (
                              <div className="ac-control-item">
                                <input type="number" className="late-input" value={att.lateMinutes||''} min={1} max={120} placeholder="min" onChange={e=>setLateMinutes(s._id,e.target.value)} />
                                <span style={{fontSize:'.72rem',color:'#9094a8'}}>min</span>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="save-footer">
                    <div style={{fontSize:'.76rem',color:'#9094a8'}}>
                      {presentCount} present · {absentCount} absent{lateCount > 0 ? ` · ${lateCount} late` : ''}
                      {attMode === 'period' && <span style={{marginLeft:8,color:'#3b6ef8',fontWeight:600}}>· Period {activePeriod}</span>}
                    </div>
                    {isLocked ? (
                      <div style={{fontSize:'.76rem',color:'#92400e',background:'#fffbeb',border:'1px solid #fde68a',borderRadius:8,padding:'7px 14px',fontWeight:600}}>🔒 Locked — contact admin</div>
                    ) : !canMark ? (
                      <div style={{fontSize:'.76rem',color:'#991b1b',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,padding:'7px 14px',fontWeight:600}}>🚫 Restricted — not class teacher</div>
                    ) : (
                      <button className="btn btn-green" onClick={attMode === 'period' ? savePeriodAttendance : saveAttendance} disabled={saving}>
                        <CheckCircleIcon />
                        {saving ? 'Saving…' : attMode === 'period' ? `Save Period ${activePeriod}` : 'Save & Lock Attendance'}
                      </button>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TeacherClasses;